// Lane/LaneStatus API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LaneStatusRequests = {
    setAsInactive: RequestConfigFunction<{ id: number }>,
    setAsImplemented: RequestConfigFunction<{ id: number }>,
    setAsPriced: RequestConfigFunction<{ id: number }>,
    setAsRejectedCustomer: RequestConfigFunction<{ id: number }>,
    setAsCancelled: RequestConfigFunction<{ id: number }>,
    setAsAwarded: RequestConfigFunction<{ id: number }>,
    setAsRejectedPricing: RequestConfigFunction<{ id: number }>,
}

const laneStatusRequests: LaneStatusRequests = {
    setAsInactive: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/inactive`,
            method: 'PATCH',
        }
    },
    setAsImplemented: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/implemented`,
            method: 'PATCH',
        }
    },
    setAsPriced: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/priced`,
            method: 'PATCH',
        }
    },
    setAsRejectedCustomer: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/rejected-customer`,
            method: 'PATCH',
        }
    },
    setAsCancelled: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/cancelled`,
            method: 'PATCH',
        }
    },
    setAsAwarded: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/awarded`,
            method: 'PATCH',
        }
    },
    setAsRejectedPricing: ({
        id,
    }) => {
        return {
            url: `lane/${id}/lanestatus/rejected-pricing`,
            method: 'PATCH',
        }
    },
}

export default laneStatusRequests
